<div class="my-3 r" style="font-size: 25px">
	<span class="glyphicon glyphicon-circle-arrow-left pointer" (click)="doPagination(true)" *ngIf="showLeft" title="Back"></span>
	<span class="glyphicon glyphicon-circle-arrow-right pointer" (click)="doPagination()" *ngIf="showRight" title="Next"></span>
</div>